// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const Heading2IconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="Heading2Icon" ref={forwardedRef} {...props}>
      <path d="M1.75 4.81h1.556V16H1.75zm.809 4.816h6.337v1.438H2.559zm5.64-4.816h1.556V16H8.198z" />
      <path d="m11.665 14.641 3.042-3.407.627-.69a25 25 0 0 0 .92-1.058 5 5 0 0 0 .545-.86 2.2 2.2 0 0 0 .223-.929c0-.36-.081-.69-.263-.969a1.67 1.67 0 0 0-.708-.64 2.3 2.3 0 0 0-.98-.22 2.24 2.24 0 0 0-1.324.42c-.404.28-.718.67-.97 1.16l-1.274-.62q.47-1.094 1.395-1.709C13.515 4.7 14.252 4.5 15.132 4.5c.677 0 1.283.13 1.799.38a3.03 3.03 0 0 1 1.223 1.039c.293.44.434.949.434 1.528 0 .48-.09.94-.283 1.39a5.3 5.3 0 0 1-.748 1.258 46 46 0 0 1-1.253 1.489l-.03.06-3.184 3.577-.354-.7h6.014v1.469h-7.085v-1.359z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const Heading2Icon = /* @__PURE__ */ Object.assign(
  Heading2IconComponent,
  { displayName: 'Heading2Icon' },
);
